<div class="ui-g ui-fluid">
  <div class="ui-g-12 ui-lg-12" *ngIf="accessDetail && !accessDetail.hasAccess">
    <h1>Access Denied</h1>
  </div>
  <div class="ui-g-12 ui-lg-12">
    <div class="card card-w-title" *ngIf="accessDetail && accessDetail.hasAccess">
      <h1>Edit Truck</h1>
      <form [formGroup]="newTruckForm" (ngSubmit)="save(newTruckForm.value)" autocomplete="off">
        <div class="ui-grid-row" *ngIf="uLevel && uLevel.organisationId">
          <div class="ui-g-6">
            <div class="ui-grid-col-4"><label [ngClass]="{}">Region</label></div>
            <div class="ui-grid-col-8">
              <p-dropdown
                [options]="regions"
                [disabled]="!regions"
                placeholder="Select region"
                [(ngModel)]="selectedRegion"
                (onChange)="onRegionChange($event.value)"
                formControlName="regionId"
                autoWidth="false"
                [style]="{ width: '100%' }"
              ></p-dropdown>
            </div>
          </div>
        </div>
        <div class="ui-grid-row" *ngIf="uLevel && uLevel.organisationId">
          <div class="ui-g-6">
            <div class="ui-grid-col-4"><label [ngClass]="{}">Depot</label></div>
            <div class="ui-grid-col-8">
              <p-dropdown
                [options]="depots"
                [disabled]="!depots || searchingDepots"
                placeholder="Select depot"
                formControlName="depotId"
                autoWidth="false"
                [style]="{ width: '100%' }"
              ></p-dropdown>
            </div>
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-g-6">
            <div class="ui-grid-col-4">
              <label [ngClass]="{}">Asset Number</label>
            </div>
            <div class="ui-grid-col-8">
              <input pInputText id="assetNumber" formControlName="assetNumber" maxlength="20" />
            </div>
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-g-6">
            <div class="ui-grid-col-4"><label [ngClass]="{}">Type</label></div>
            <div class="ui-grid-col-8">
              <p-dropdown
                [options]="truckTypes"
                placeholder="Select vehicle type"
                formControlName="typeId"
                autoWidth="false"
                [style]="{ width: '100%' }"
              ></p-dropdown>
            </div>
          </div>
        </div>

        <div class="ui-grid-row">
          <div class="ui-g-6">
            <div class="ui-grid-col-4"><label [ngClass]="{}">Vehicle Capacity, kg</label></div>
            <div class="ui-grid-col-8">
              <input
                type="number"
                pInputText
                id="capacity"
                formControlName="capacity"
                (keydown)="limitCapacity($event)"
                (keyup)="limitCapacity($event)"
                min="0"
                max="1000000"
              />
            </div>
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-g-6">
            <div class="ui-grid-col-4"><label [ngClass]="{}">Towing Capacity, kg</label></div>
            <div class="ui-grid-col-8">
              <input
                type="number"
                pInputText
                id="capacityTowing"
                formControlName="capacityTowing"
                (keydown)="limitCapacityTowing($event)"
                (keyup)="limitCapacityTowing($event)"
                min="0"
                max="1000000"
              />
            </div>
          </div>
        </div>

        <div class="ui-grid-row">
          <div class="ui-g-6">
            <div class="ui-grid-col-4">
              <label [ngClass]="{}">Registration Number</label>
            </div>
            <div class="ui-grid-col-8">
              <input pInputText id="registration" formControlName="registration" maxlength="8" />
            </div>
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-g-6">
            <div class="ui-grid-col-4">
              <label [ngClass]="{}">Make</label>
            </div>
            <div class="ui-grid-col-8">
              <input pInputText id="make" formControlName="make" maxlength="100" />
            </div>
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-g-6">
            <div class="ui-grid-col-4">
              <label [ngClass]="{}">Model</label>
            </div>
            <div class="ui-grid-col-8">
              <input pInputText id="model" formControlName="model" maxlength="100" />
            </div>
          </div>
        </div>

        <div class="ui-grid-row">
          <div class="ui-g-6">
            <div class="ui-grid-col-4"><label [ngClass]="{}">Description</label></div>
            <div class="ui-grid-col-8">
              <textarea
                pInputTextArea
                rows="3"
                style="width: 100%"
                id="description"
                formControlName="description"
                maxlength="100"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="footerPanel ui-grid-row">
          <button
            type="button"
            (click)="Cancel()"
            pButton
            label="Cancel"
            class="btn-to-right"
            icon="fa ui-icon-close"
          ></button>
          <button
            type="submit"
            class="green-btn btn-to-right"
            pButton
            icon="fa ui-icon-check"
            label="Save"
            [disabled]="newTruckForm.invalid"
          ></button>
        </div>
      </form>
    </div>
  </div>
</div>
